<template>
  <div class="register">
    <Header></Header>
    <Nav></Nav>
    <Toptitle title="忘记密码"></Toptitle>
    <div class="login_c register_c">
      <div class="img"></div>
      <div class="login_right">
        <div class="login_tit">
          <p>忘记密码</p>
          <!-- <p>已有账号？返回<router-link to="/login" tag="a">登录</router-link>
          </p> -->
        </div>
        <input type="text" placeholder="请输入手机号码" :class=" phoneEroText !=''?'nobottom' : '' " v-model="dataJson.phone">
        <p class="errorText" v-show="phoneEroText!=''">{{phoneEroText}}</p>

        <input type="password" placeholder="请输入密码" :class=" passwordEroText !=''?'nobottom' : '' " v-model="dataJson.password">
        <p class="errorText" v-show="passwordEroText!=''">{{passwordEroText}}</p>


        <div :class="['code','imgCode',imgCodeEroText !=''?'nobottom' : '' ]">
          <input type="text" placeholder="请输入图形验证码" v-model="imgCode">
          <img :src="codeImg" @click="getImgCode()" />
        </div>
        <p class="errorText" v-show="imgCodeEroText!=''">{{imgCodeEroText}}</p>

        <div :class="['code',codeEroText !=''?'nobottom' : '' ]">
          <input type="text" placeholder="请输入验证码" v-model="dataJson.code">
          <span class="botton" @click="getCode()">{{codeText}}</span>
        </div>
        <p class="errorText" v-show="codeEroText!=''">{{codeEroText}}</p>

        <span class="botton" @click="submit()">提交</span>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        passwordEroText: '',
        phoneEroText: '',
        imgCodeEroText: '',
        codeEroText: '',
        imgCode: '',
        codeImg: '',
        dataJson: {
          password: '',
          phone: '',
          code: '',
          sessionid: ''
        },
        codeText: '获取验证码',
        time: 60,
        sessionId: '',
        timer:''

      }
    },
    methods: {
      getCode() {
        if (this.dataJson.phone == '') {
          this.phoneEroText = '手机号码不能为空'
          return
        } else {
          this.phoneEroText = ''
        }

        if (!this.$isTelAvailable(this.dataJson.phone)) {
          this.phoneEroText = '手机格式有误'
          return
        } else {
          this.phoneEroText = ''
        }

        if (this.imgCode == '') {
          this.imgCodeEroText = '图形验证码不能为空'
          return
        } else {
          this.imgCodeEroText = ''
        }

        if (this.codeText == '获取验证码') {
          this.timer = setInterval(() => {
            this.time--;
            this.codeText = '剩余' + this.time + 's'
            if (this.time == 0) {
              this.codeText = '获取验证码'
              this.time = 60
              clearInterval(this.timer)
            }
          }, 1000)
          this.sendSms()
        }
      },
      submit() {
        if (this.dataJson.phone == '') {
          this.phoneEroText = '手机号码不能为空'
          return
        } else {
          this.phoneEroText = ''
        }
        
        if (this.dataJson.password == '') {
          this.passwordEroText = '密码不能为空'
          return
        } else {
          this.passwordEroText = ''
        }

        if (this.imgCode == '') {
          this.imgCodeEroText = '图形验证码不能为空'
          return
        } else {
          this.imgCodeEroText = ''
        }

        if (this.dataJson.code == '') {
          this.codeEroText = '验证码不能为空'
          return
        } else {
          this.codeEroText = ''
        }

        this.axios.post('api/index/forget.do', this.qs({phone:this.dataJson.phone,password:this.$md5(this.dataJson.password),code:this.dataJson.code,sessionid:this.dataJson.sessionid})).then(res => {
          if (res.data.resultCode == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({
              name: 'login'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
            
          }
        })
      },
      getImgCode() {
        this.axios.post('verifycode/getImageCodeB64.do', this.qs({
          width: 200,
          height: 80,
          isNeedPrefix: 1
        })).then(res => {
          if (res.status == 200) {
            this.codeImg = res.data.image
            this.sessionId = res.data.sessionId
          }
        })
      },
      sendSms() {
        this.axios.post('api/index/getForgetVerifyCode.do', this.qs({
          phone: this.dataJson.phone,
          verifycode: this.imgCode,
          sessionid: this.sessionId
        })).then(res => {
          console.log(res)
          if(res.data.resultCode==0){
            this.dataJson.sessionid = res.data.sessionid
          }else{
            this.$message({
              message: res.data.message,
              type: 'error'
            });
            this.codeText = '获取验证码'
            this.time = 60
            clearInterval(this.timer)
          }
          
        })
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    computed: {

    },
    mounted() {
      this.getImgCode()
    },
    watch:{
      'dataJson.phone':function(newVal,oldVal){
        if(newVal!=''){
          this.phoneEroText = ''
        }
      },
      'dataJson.password':function(newVal,oldVal){
        if(newVal!=''){
          this.passwordEroText = ''
        }
      },
      'imgCode':function(newVal,oldVal){
        if(newVal!=''){
          this.imgCodeEroText = ''
        }
      },
      'dataJson.code':function(newVal,oldVal){
        if(newVal!=''){
          this.codeEroText = ''
        }
      },
    }
  }
</script>

<style>
</style>
